import type { FilterGroup } from 'src/utils/common'
import React, { useEffect, useContext } from 'react'
import { observer, useLocalObservable } from 'mobx-react'
import { TreeContext, ListSearch, ChartLineBar, ChartSan, ChartPie } from 'src/components'
import { appStore } from 'src/stores'
import { $api, $consts } from 'src/plugins'
import { getMenuFormParams } from './helper'
import { initFilter, extendRulesAndGroups } from 'src/utils/common'
import 'src/styles/components/root/chartPage.less'

type FormData = {
  formId?: string,
  filterGroup?: FilterGroup,
}

type Props = {
  formCode: string,
  formData?: FormData,
}

const ChartPropsContext = React.createContext<Props>({ formCode: '' })
const ChartContext = React.createContext<any>(undefined)

const CheckChartPage = observer(() => {
  const chart = useContext(ChartContext)

  if (!chart.chartConfig.Nav_PageCharts?.length) return null

  return chart.chartConfig.Nav_PageCharts.map((config: any, index: number) => {
    if (!chart.chartData.length || !chart.chartData[index]) return null

    switch (config.CHART_TYPE) {
      case $consts['TABLE/CHART_TYPE_LINE']:
      case $consts['TABLE/CHART_TYPE_BAR']:
        return <ChartLineBar key={`${config.ID}_${index}`} chartData={chart.chartData[index]} style={{ height: 300 }} />
      case $consts['TABLE/CHART_TYPE_PIE']:
        return <ChartPie key={`${config.ID}_${index}`} chartData={chart.chartData[index]} style={{ height: 300 }} />
      case $consts['TABLE/CHART_TYPE_SAN']:
        return <ChartSan key={`${config.ID}_${index}`} chartData={chart.chartData[index]} />
      default:
        return null
    }
  })
})

const ChartPage = (props: Props) => {
  const tree = useContext(TreeContext)

  const state = useLocalObservable(() => {
    return {
      // 图表表单配置
      chartConfig: {} as any,
      setChartConfig (config: any) {
        this.chartConfig = config
      },
      getChartConfig (formCode: string) {
        const { OrgId } = appStore.current.headers
        const payload = initFilter({ OrgId, Keyword: formCode })
        $api['chart/getChartPageConfigInfo'](payload)
          .then((res: any) => {
            res && state.setChartConfig(res)
            return res
          })
      },
      // 图表表单数据
      chartData: [] as any[],
      setChartData (data: any[]) {
        this.chartData = data
      },
      getChartData (searchFilterGroup: any) {
        const promiseFunc = this.chartConfig.Nav_PageCharts?.map((chart: any) => {
          const { OrgId } = appStore.current.headers
          const {
            API_URL: api,
            AUTH_ORG_CODES: AuthOrgCodes,
            FILTER_ORG_TYPE: OrgType,
            IGNORE_ORG_RULE: IgnoreOrgRule
          } = chart
          const payload: any = initFilter({ OrgId, OrgType, Keyword: props.formData?.formId, AuthOrgCodes, IgnoreOrgRule })
          // 菜单参数
          payload.MenuParameter = appStore.current.activeMenu.MENU_FORM_PARAMS
          // 表单参数
          const formParams = getMenuFormParams(appStore.current.activeMenu)
          for (const [key, value] of Object.entries(formParams)) {
            payload[key] = value
          }
          // 树参数
          tree?.selectedKeys && (payload.TreeSelected = tree.selectedKeys)
          // ListSearch 搜索参数
          searchFilterGroup && extendRulesAndGroups(payload, searchFilterGroup)
          // 额外请求参数
          props.formData?.filterGroup && extendRulesAndGroups(payload, props.formData.filterGroup)

          return $api['app/getDataByPost'](payload, { url: api })
        })

        Promise.all(promiseFunc).then(datas => {
          this.setChartData(datas)
        })
      },
    }
  })

  // 树表单配置/数据
  useEffect(() => {
    state.getChartConfig(props.formCode)
  }, [props.formCode])

  return (
    <ChartPropsContext.Provider value={props}>
      <ChartContext.Provider value={state}>
        <div className='chart-page'>
          <ListSearch formCode={props.formCode} onSearch={state.getChartData} />
          <CheckChartPage />
        </div>
      </ChartContext.Provider>
    </ChartPropsContext.Provider>
  )
}

export { ChartPropsContext, ChartContext }
export default ChartPage